import type { StaticLayerPayload } from "@config";
import { NumbersLibrary } from "@library-elements/animated-numbers";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: NumbersLibrary,
};

export const AnimatedNumbers = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
